import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { ThirdPartyPayoff } from '../../../../models/FlowOfFunds/flow-of-funds.model';

export interface AddThirdPartyPayoffRowRequest {
    engagementId: number;
}

// POST creates the DAQI row first, then its FoF sibling; the response row has
// no cells yet (genuine for a new row), so the caller refetches the flow of
// funds afterwards to pull the fresh DAQI cells in.
export const AddThirdPartyPayoffRow = createAsyncThunk(
    'flowOfFunds/addThirdPartyPayoffRow',
    async (params: AddThirdPartyPayoffRowRequest, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.post(
                `/api/flowOfFunds/${params.engagementId}/thirdPartyPayoffs/rows`
            );

            if (response.status !== 200) {
                throw new Error('Failed to add a pay-off row');
            }

            return response.data as ThirdPartyPayoff;
        } catch (error) {
            createNotification('Could not add a new pay-off row.', 'error');
            throw error;
        }
    }
);
